var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18182 14.0909V1H16.2727V14.0909C16.2727 14.8624 15.9662 15.6024 15.4207 16.1479C14.8751 16.6935 14.1352 17 13.3636 17",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4545 14.0909H1C1 14.8625 1.30649 15.6024 1.85205 16.1479C2.39761 16.6935 3.13755 17 3.90909 17H13.3636C12.5921 17 11.8522 16.6935 11.3066 16.1479C10.761 15.6024 10.4545 14.8625 10.4545 14.0909Z",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.54544H13.3636",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09088 7.54544H7.54543",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.4546H13.3636",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09088 10.4546H7.54543",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.63635H13.3636",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09088 4.63635H7.54543",
    stroke: "#647787",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9914 14.5909C10.0979 15.3094 10.4321 15.9799 10.9515 16.5H3.90909C3.27016 16.5 2.6574 16.2462 2.20561 15.7944C1.87356 15.4623 1.64845 15.0433 1.55245 14.5909H9.9914Z",
    fill: "#647787",
    stroke: "#647787"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllOrders);
export default __webpack_public_path__ + "static/media/all-orders.e7206de300277f591e4b671df2ecd7e3.svg";
export { ForwardRef as ReactComponent };